import { render, staticRenderFns } from "./Paymentdetails.vue?vue&type=template&id=081e3cba&scoped=true"
import script from "./Paymentdetails.vue?vue&type=script&lang=js"
export * from "./Paymentdetails.vue?vue&type=script&lang=js"
import style0 from "./Paymentdetails.vue?vue&type=style&index=0&id=081e3cba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081e3cba",
  null
  
)

export default component.exports